<div class="top_living_header_wrapper">
    <div class="container ">
        <h1 class="top_living_header text-center" >Golden Properties</h1>
    </div>
</div>
<div class="container">

        <div class="row prop_filters">
            <div class="col-md-2">
                <div class="shadow p-3 mb-4"> 
                    <div style="width: 100%;"> 
                        <select class="filter_type" [ngModel]="searchProperty.city" (ngModelChange)="changeCity($event)">
                            <option value="city" disabled class="search_location">City </option>
                            <option *ngFor="let x of citySel" [ngValue]="x.id">{{x.text}} </option>
                        </select> 
                    </div>      
                </div>  
            </div> 
            <div class="col-md-3">
                <div class="shadow p-2 mb-4"> 
                    <div class="locSearch"> 
                        <input style="border: transparent; outline: none; width: 100%;background-color:white;" [ngModel]="addressActive" (ngModelChange)="addressActive = $event" placeholder="Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control" #search >
                    </div>     
                </div>
            </div>
            <div class="col-md-2">
                <div class="shadow p-3  mb-4">                
                    <div> 
                        <select class="filter_type" [ngModel]="searchProperty.radius" (ngModelChange)="changeRadius($event)">
                            <option value="0" disabled class="search_radius">Radius (in Km) </option>
                            <option *ngFor="let x of radiusSel" [ngValue]="x.id">{{x.text}} </option>
                        </select>
                    </div>     
                </div>
            </div>
            <div class="col-md-2">
                <div class="shadow p-3  mb-4"> 
                    <div> 
                        <select class="filter_type" [ngModel]="searchProperty.gender" (ngModelChange)="changeGender($event)">
                            <option value="0" disabled class="search_gender">Gender </option>
                            <option *ngFor="let x of genderSel" [ngValue]="x.id">{{x.text}} </option>
                        </select>
                    </div>    
                </div>
            </div> 
            <div class="col-md-3">
                <div class="shadow p-3  mb-4"> 
                    <div> 
                        <select class="filter_type" [ngModel]="searchProperty.sharetype" (ngModelChange)="changePropertyType($event)">
                            <option value="4" disabled class="search_propertyType">Property Type </option>
                            <option *ngFor="let x of propertySel" [ngValue]="x.id">{{ x.text }} </option>
                        </select>
                    </div>    
                </div>
            </div>
        </div>
        <h2 class="mt-4 mb-4"> {{ goldenProp }} available golden grade A+ properties are found on rent in <span style="text-transform: capitalize;"> {{ searchProperty.city }} </span> .</h2>
<!--------------------------------- Filters for small screen ------------------------------------>

    <div class="row ">
        <div class="col-md-9">
            <div *ngIf="loader == true" style="height: 300px; display: flex; justify-content: center; align-items: center;">
                <img src="assets/images/loading.gif" class="faLoader" width="50" height="50" />
            </div> 
            <div class="row prop_holder justify-content-around" *ngIf="loader == false">
                <div class="prop_card mt-4" *ngFor="let gp of goldenProperty">
                    <div class="propertyList" [routerLink]="['/property', gp.property.id]" >
                        <div class="golden_prop_image" >
                            <img *ngIf="gp.property.image != null" src="{{ gp.property.image.url }}" >
                            <img *ngIf="gp.property.image == null" src="assets/images/coming-soon.png" class="p-4">
                        </div>
                        <div class="pl-3 pr-3">
                            <h1 class="gold_prop_name"> {{ gp.property.name }} </h1>
                            <div class="d-flex justify-content-between" style="margin-top: 10px; margin-bottom: 20px;">
                                <div>
                                    <p style="font-size: 14px; margin-bottom: 0;">Starts From</p>
                                    <p class="prop_card_rent"> &#x20B9; {{ gp.property.rent }} </p> 
                                </div>
                                <p class="prop_card_loc"><fa-icon [icon]="faMapMarker" [ngStyle]="{'color' : gp.property.status == 'occupied' ? 'gray' : 'coral'}"></fa-icon> {{ gp.property.locality }} </p> 
                            </div>
                            <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 10px;">
                                <p class="prop_card_gender" [ngStyle]="{'color' : gp.property.gender == 2 && gp.property.status != 'occupied'? '#F94B75' : gp.property.status == 'occupied' && gp.property.gender != 1 ? '#339af0' : gp.property.status == 'occupied' ? 'gray' : 'lightseagreen' }">
                                    {{ gp.property.gender == 0?"All" : gp.property.gender == 1?"Boys": gp.property.gender == 2?"Girls": "" }} </p>
                                <p class="prop_card_status" [ngStyle]="{'color' : gp.property.status == 'partial' ? '#339af0' : gp.property.status == 'available' ? '#4BB543' : 'grey'  }">{{gp.property.status }}</p>
                            </div>
                            <hr style="margin-top: 0;">
                            <p class="prop_card_footer">{{gp.property.totalrooms}} BHK</p>
                            <p class="prop_card_footer">{{gp.property.sqftsuper}} sq.ft</p>
                        </div>
                    </div>
                </div>
            </div>    
        </div>  
        <div class="col-md-3">
            
        </div>
    </div>
</div>